import type { RequestSchema } from '@/types/request';

export const getProducts: RequestSchema<API.MembershipProduct[]> = {
  name: 'getProducts',
  input: '/api/v1/product',
};

export const getServices: RequestSchema<API.Service[]> = {
  name: 'getServices',
  input: '/api/v1/service',
};

export const getMyOrders: RequestSchema<API.MembershipOrder[]> = {
  name: 'getMyOrders',
  input: '/api/v1/order/me',
};
